import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";

import { useClientApi } from "@ctv/core";

import {
  DOCUMENT_REQUIREMENT_API,
  DocumentRequirementRequest,
  DocumentRequirementResponse,
} from "../apis";

import { Document } from "@ctv/shared-core/src";
import { useRegisterContent } from "./RegisterContentContext";

export type RequiredDocumentState = {
  loading: boolean;
  documents: Document[];
  creditAssessmentDocuments: Document[];
};

const RequiredDocumentContext = createContext<RequiredDocumentState>({
  creditAssessmentDocuments: [],
  documents: [],
  loading: true,
});

export function RequiredDocumentProvider(props: PropsWithChildren) {
  const [data, setData] = useState<RequiredDocumentState>({
    loading: true,
    documents: [],
    creditAssessmentDocuments: [],
  });

  const { token } = useRegisterContent();

  const getDocuments = useClientApi<
    DocumentRequirementResponse,
    DocumentRequirementRequest
  >({
    domain: "management",
    method: "post",
    path: DOCUMENT_REQUIREMENT_API,
  });

  useEffect(() => {
    setData((s) => ({ ...s, loading: true }));

    getDocuments({ token }).then((res) => {
      if (res.success) {
        setData({
          loading: false,
          ...res.data,
        });
      } else {
        setData({
          loading: true,
          creditAssessmentDocuments: [],
          documents: [],
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run once
  }, []);

  return (
    <RequiredDocumentContext.Provider value={data}>
      {props.children}
    </RequiredDocumentContext.Provider>
  );
}

export function useRequiredDocument() {
  return useContext(RequiredDocumentContext);
}
